import { Spin } from 'antd'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const NotMatch = () => {
  const [s, setS] = useState(false)
  return (
    <>
      <button onClick={() => setS(!s)}>sd</button>
      <Spin spinning={s}>
        <div className="not-match">
          <p className="not-match-oh">uh-oh!</p>
          <p className="not-match-404">404 Error</p>
          <p className="not-match-contents">
            Page not found{' '}
            <span role="img" aria-label="">
              🔍
            </span>
            <br />
            We are sorry but the page you are looking for does not exist.
            <br />
            You could return homepage.
          </p>
          <Link to={{ pathname: '/' }}>
            <button className="not-match-btn">Back to Home</button>
          </Link>
          <div className="not-match-img-box">
            <img
              src={require('../img/404_error_emoji_Large.png').default}
              className="not-match-img"
              alt="not match img"
            />
          </div>
        </div>
      </Spin>
    </>
  )
}

export default NotMatch
